<script setup lang="ts">
import ProfileNavigation from '~/components/ProfileNavigation.vue';
</script>

<template>
	<div class="lg:bg-white flex flex-col bg-gray-100">
		<div class="lg:grid lg:grid-cols-12 lg:py-7xl lg:gap-8xl">
			<ProfileNavigation />
			<div class="lg:col-span-9 pb-3xl lg:mt-0 lg:gap-7xl gap-m flex flex-col">
				<slot />
			</div>
		</div>
	</div>
</template>
